import React from "react";
import { Flex, Text, VStack } from "@chakra-ui/react";
import { Wrapper } from "components";
import { useAuth } from "duck";
import { User } from "requests";
import { Edit, View } from "./components";

const UserProfile: React.FC = () => {
  const [{ user }] = useAuth();
  const [edit, setEdit] = React.useState(false);

  return (
    <Flex flex="1" flexDirection="column" gridGap="24px">
      <Wrapper>
        <VStack alignItems="right" spacing={8}>
          <Text fontSize="2xl" fontWeight="semibold">
            Profile
          </Text>
        </VStack>
      </Wrapper>

      <Wrapper>
        {edit ? (
          <Edit
            initialValues={user as User}
            onCancel={() => setEdit(false)}
            onSuccess={() => setEdit(false)}
          />
        ) : (
          <View initialValues={user as User} onEdit={() => setEdit(true)} />
        )}
      </Wrapper>
    </Flex>
  );
};

export default UserProfile;
